<template>
  <v-row>
    <v-col cols="12">
      <v-sheet outlined>
        <v-row class="pa-4">

          <v-col cols="12">
            <h2 class="font-weight-light">Datos personales:</h2>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="name"
              label="Nombre completo*"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="lastname"
              label="Apellido*"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="dni"
              label="DNI/Pasaporte/Cédula*"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            >
            <v-text-field
              type="date"
              v-model="birthdate"
              label="Fecha de nacimiento*"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un genero' }, ...genders]"
              v-model="gender_id"
              item-text="name"
              item-value="id"
              label="Genero*"
              outlined
            ></v-select>
          </v-col>
          
          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un canal de comunicación' }, ...communication_channels]"
              v-model="communication_channel_id"
              item-text="name"
              item-value="id"
              label="Canal de cominicacíon que usa con mas frecuencia*"
              outlined
            ></v-select>
          </v-col>

          <v-col
            cols="12"
          >
            <v-textarea
              v-model="about_me"
              label="Acerca de mí*"
              outlined
              :counter="500"
              :maxlength="500"
              placeholder="Soy estudiante de Economía y poseo excelentes habilidades de análisis, planificación y trabajo en equipo que he adquirido durante mis estudios universitarios, las prácticas y voluntariados en los que participé. Soy el capitán del equipo de futbol de mi universidad y como tal me destaco en mi rol de liderazgo.
Me gusta mucho participar de prácticas en el sector de comercio para seguir desarrollando mis habilidades y conocimientos sobre marketing. 
Gracias por leer sobre mí.
Saludos!"
            ></v-textarea>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            >
            <v-text-field
              v-model="phone_number"
              label="Celular*"
              outlined
              placeholder="CÓDIGO PAÍS + CÓDIGO ÁREA + NÚMERO DE CELULAR"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="linkedin"
              label="Linkedin"
              outlined
              placeholder="https://www.linkedin.com/in/universidad-nacional-del-litoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="youtube"
              label="Youtube"
              outlined
              placeholder="https://youtube.com/vinculacionunl"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="facebook"
              label="Facebook"
              outlined
              placeholder="https://www.facebook.com/UNLitoralAr/"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="instagram"
              label="Instagram"
              outlined
              placeholder="https://www.instagram.com/unlitoral_/"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="twitter"
              label="Twitter"
              outlined
              placeholder="https://twitter.com/UNLitoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="telegram"
              label="Telegram"
              outlined
              placeholder="https://t.me/unlitoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="discord"
              label="Discord"
              outlined
              placeholder="https://www.discord.com/unlitoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="twitch"
              label="Twitch"
              outlined
              placeholder="https://www.twitch.tv/unlitoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="tiktok"
              label="TikTok"
              outlined
              placeholder="https://www.tiktok.com/@unlitoral"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12" xl="6" md="6" sm="12" xs="12"
          >
            <v-text-field
              v-model="snapchat"
              label="Snapchat"
              outlined
              placeholder="https://www.snapchat.com/profile/unlitoral"
            ></v-text-field>
          </v-col>

        </v-row>
      </v-sheet>    

      <v-sheet outlined class="mt-4">
        <v-row class="pa-4">    
          <v-col cols="12">
            <h2 class="font-weight-light">Estudios:</h2>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12">
            <v-select
              :items="[{ id: null, name: 'Selecciona un estudio' }, ...completed_studies]"
              v-model="completed_studie_id"
              item-text="name"
              item-value="id"
              label="Estudios alcanzados*"
              outlined
            ></v-select>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            v-if="completed_studie_id==null||completed_studie_id==1||completed_studie_id==2"
            >
            <v-text-field
              v-model="secundary_tertiary_institute"
              :disabled="completed_studie_id==null"
              label="Institución*"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            v-if="completed_studie_id==null||completed_studie_id==1||completed_studie_id==2"
            >
            <v-text-field
              v-model="secundary_tertiary_career"
              :disabled="completed_studie_id==null"
              label="Título o carrera*"
              required
              outlined
            ></v-text-field>
          </v-col>

          <template v-if="completed_studie_id==3||completed_studie_id==4">
            <v-col 
              cols="12" xl="6" md="6" sm="12" xs="12"
              >
              <v-select
                :items="universities"
                v-model="university"
                label="Universidad*"
                outlined
              ></v-select>
            </v-col>

            <v-col 
              cols="12" xl="6" md="6" sm="12" xs="12"
              v-if="university=='unl'">
              <v-select
                :items="[{ id: null, name: 'Selecciona una unidad académica' }, ...academic_units]"
                v-model="academic_unit_id"
                v-on:change="getCareers"
                item-text="name"
                item-value="id"
                label="Unidad Academica*"
                outlined
              ></v-select>
            </v-col>

            <v-col 
              cols="12" xl="6" md="6" sm="12" xs="12"
              v-if="university=='unl'">
              <v-select
                :items="[{ id: null, name: 'Selecciona una carrera' }, ...careers]"
                v-model="career_id"
                item-text="name"
                item-value="id"
                label="Carreras*"
                outlined
              ></v-select>
            </v-col>

            <v-col
              cols="12" xl="6" md="6" sm="12" xs="12"
              v-if="university=='otro'"
            >
              <v-text-field
                v-model="other_university"
                label="Universidad*"
                required
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              cols="12" xl="6" md="6" sm="12" xs="12"
              v-if="university=='otro'"
            >
              <v-text-field
                v-model="other_career"
                label="Carrera*"
                required
                outlined
              ></v-text-field>
            </v-col>
          </template>
        </v-row>
      </v-sheet>

      <v-sheet outlined class="mt-4">
        <v-row class="pa-4">  
          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>
          <v-col 
            cols="12" xl="4" md="4" sm="12" xs="12"
            >
            <v-select
              v-model="country_id"
              :items="[{ id: null, name: 'Selecciona un país' }, ...countries]"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col 
            cols="12" xl="8" md="8" sm="12" xs="12"
            v-if="country_id!=argentina_id"
            >
            <v-text-field
              v-model="other_country"
              :disabled="country_id==null"
              label="Estado/region/provincia*"
              required
              outlined
            ></v-text-field>
          </v-col>
          <v-col 
            cols="12" xl="4" md="4" sm="12" xs="12"
            v-if="country_id==argentina_id"
            >
            <v-select
              :items="[{ id: null, name: 'Selecciona una provincia' }, ...provincias]"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col 
            cols="12" xl="4" md="4" sm="12" xs="12"
            v-if="country_id==argentina_id"
            >
            <v-select
              :items="[{ id: null, name: 'Selecciona una localidad' }, ...localidades]"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

        </v-row>
      </v-sheet>
       
      <v-sheet outlined class="mt-4">
        <v-row class="pa-4">  
          <v-col cols="12">
            <h2 class="font-weight-light">Correo electrónico del integrante*:</h2>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            >
            <v-text-field
              v-model="email"
              label="Correo electrónico*"
              required
              outlined
            ></v-text-field>
          </v-col>

          <v-col 
            cols="12" xl="6" md="6" sm="12" xs="12"
            >
            <v-text-field
              v-model="confirm_email"
              label="Confirmar correo electrónico*"
              required
              outlined
            ></v-text-field>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-8 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'myTeam'}"
        :disabled="btn_loading"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />

      <v-btn
        depressed
        :loading="btn_loading"
        color="primary"
        @click="save()"
        >
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_errors"
      persistent
      max-width="490">
      <v-card>
        <v-card-title class="text-h5">
          Atención
        </v-card-title>
        <v-card-text>
          <p v-for="error in errors" :key="error">{{ error }}<br></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="info darken-1"
            text
            @click="dialog_errors = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'addEntrepreneur',
    data: () => ({
      loading:true,
      btn_loading:false,

      id: null,
      
      name:'',
      lastname:'',
      dni:'',
      email:'',
      confirm_email:'',
      birthdate:null,
      about_me:null,
      phone_number:'',
      linkedin:null,
      youtube:null,
      facebook: null,
      instagram: null,
      twitter: null,
      telegram: null,
      discord: null,
      twitch: null,
      tiktok: null,
      snapchat: null,
      cv: null,

      gender_id: null,
      genders:[],
      
      user_id:null,
      convocation_form_id:null,

      country:null,
      country_id: null,
      other_country:'',
      argentina_id: null,
      countries: [],

      provincia_id: null,
      provincias:[],

      localidad_id: null,
      localidades:[],
      legal_address:'',

      completed_studie_id: null,
      completed_studies: [],

      secundary_tertiary_institute: '',
      secundary_tertiary_career: '',

      university: null,
      universities:[
        { text: 'Seleccione una universidad', value: null },
        { text: 'Universidad Nacional del Litorial', value: 'unl' },
        { text: 'Otra', value: 'otro' }
      ],

      academic_unit_id: null,
      academic_units:[],

      career_id: null,
      careers: [],

      other_university: '',
      other_career: '',

      communication_channel_id: null,
      communication_channels:[],

      position_id: null,
      positions:[],

      dialog_errors: false,
      dialog_roles: false,

      error:'',
      errors:[],

      status:false
    }),
    computed: {
      ...mapGetters([ 
          'convocation_form', 'user', 'edition'
      ])
    },
    methods:{
      async getComunicationChannels(){
        try {
          await axios.get('comunication-channels').then(response =>{
            this.communication_channels = response.data.data.comunication_channels
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getPositions(){
        try {
          await axios.get('positions').then(response =>{
            this.positions = response.data.data.positions
            
            if(this.positions.length>0){
              this.position_id = this.positions[0].id
            }

          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getCountries(){
        try {
          await axios.get('countries').then(response =>{
            this.countries = response.data.data.countries

            this.countries.forEach(element=>{
              if(element.name=='Argentina'){
                this.argentina_id = element.id
              }
            })
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getProvincias(){
        try {
          await axios.get('provincias').then(response =>{
            if(response.data.length!==0){
              this.provincias = response.data.provincias
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidades(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            if(response.data.length!==0){
              this.localidades = response.data.provincia.localidads
            }
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },

      async getCompletedStudies(){
        try {
          await axios.get('completed-studies').then(response =>{
            if(response.data.length!==0){
              this.completed_studies = response.data.completed_studies

            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getAcademicsUnits(){
        try {
          await axios.get('academic-units').then(response =>{
            if(response.data.length!==0){
              this.academic_units = response.data.academic_units
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getCareers(){
        try {
          await axios.get('academic-units/'+this.academic_unit_id).then(response =>{
            if(response.data.length!==0){
              this.careers = response.data.academic_unit.careers
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },
      
      async getGenders(){
        try {
          await axios.get('genders').then(response =>{
            if(response.data.length!==0){
              this.genders = response.data.genders
            }
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async save(){
        this.btn_loading = true
        this.errors=[]
        try {
          await axios.post('entrepreneurial-profiles/add', {
            edition_id: this.edition.edition.id,
            convocation_form_id: this.convocation_form.convocation_form.id,
            
            name: this.name,
            lastname: this.lastname,
            dni: this.dni,
            gender_id: this.gender_id,
            communication_channel_id: this.communication_channel_id,
            birthdate: this.birthdate,
            about_me: this.about_me,
            phone_number: this.phone_number,
            linkedin: this.linkedin,
            facebook: this.facebook,
            youtube: this.youtube,
            instagram: this.instagram,
            twitter: this.twitter,
            telegram: this.telegram,
            discord: this.discord,
            twitch: this.twitch,
            tiktok: this.tiktok,
            snapchat: this.snapchat,
            position_id: this.position_id,
            country_id: this.country_id,
            other_country: this.other_country,
            provincia_id: this.provincia_id,
            localidad_id: this.localidad_id,
            completed_studie_id: this.completed_studie_id,
            secundary_tertiary_institute: this.secundary_tertiary_institute,
            secundary_tertiary_career: this.secundary_tertiary_career,
            university: this.university,
            academic_unit_id: this.academic_unit_id,
            career_id: this.career_id,
            other_university: this.other_university,
            other_career: this.other_career,
            cv: this.cv,

            email: this.email,
            confirm_email: this.confirm_email
          })
          this.btn_loading = false
          this.$router.push({ name: 'myTeam'})
        } catch (error) {
          if (error.response && error.response.status === 422) {
            this.errors = Object.values(error.response.data.errors).flat();
          } else {
            this.errors = ['Ocurrió un error inesperado.'];
          }
          this.btn_loading = false;
          this.dialog_errors = true;
        }
      }
    },
    created(){
      Promise.all([
        this.getComunicationChannels(),
        this.getPositions(),
        this.getCountries(),
        this.getProvincias(),
        this.getLocalidades(),
        this.getCompletedStudies(),
        this.getAcademicsUnits(),
        this.getCareers(),
        this.getGenders(),
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>